import { render, staticRenderFns } from "./SCATTER_COURTPLANE.vue?vue&type=template&id=96fe2ad6&scoped=true"
import script from "./SCATTER_COURTPLANE.vue?vue&type=script&lang=js"
export * from "./SCATTER_COURTPLANE.vue?vue&type=script&lang=js"
import style0 from "./SCATTER_COURTPLANE.vue?vue&type=style&index=0&id=96fe2ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe2ad6",
  null
  
)

export default component.exports